import {ActionType} from '@typescript/common/actionTypes';
import {GDL} from 'constants/actions';

/**
 * Start saga to fill global data layer
 * @param {string} pageName methods counter
 * @return {ActionType} action
 */
export function globalDataLayerPageSaga(pageName: string): ActionType<string> {
    return {
        type: GDL.GLOBAL_DATA_LAYER_READY_TO_FILL,
        payload: pageName,
    };
}
